<template>
  <a
    v-if="linkUrl"
    :href="linkUrl"
    :target="linkTarget"
  >
    <slot></slot>
  </a>
  <router-link
    v-else-if="product.type !== ProductType.BANNER"
    :to="product | link"
  >
    <slot></slot>
  </router-link>
</template>
<script>
  import { ProductType } from '@/shared/enums';
  import { link } from '@/index/shared/filters';

  export default {
    enums: {
      ProductType,
    },
    filters: {
      link,
    },
    props: {
      product: Object,
    },
    computed: {
      linkTarget() {
        return this.product && this.product.externalView && '_blank';
      },
      linkUrl() {
        return this.product && this.product.urlWeb;
      },
    },
  };
</script>
